import { AccountData } from 'src/stores/useVelocityAccountsStore';
import { VaultDepositorData } from 'src/hooks/query/vaults/types';
import { IfData } from 'src/utils/insuranceFund';
import { UIMarket } from '@velocity-exchange/common';

export interface IFStakeItem {
	marketIndex: number;
	ifData: IfData;
	poolId: number;
	market: UIMarket;
}

export const isAccountData = (
	item: AccountData | VaultDepositorData | IFStakeItem
): item is AccountData => {
	return 'userKey' in item;
};

export const isVaultData = (
	item: AccountData | VaultDepositorData | IFStakeItem
): item is VaultDepositorData => {
	return 'vault' in item && 'vaultDepositor' in item;
};

export const isIFStakeData = (
	item: AccountData | VaultDepositorData | IFStakeItem
): item is IFStakeItem => {
	return 'ifData' in item && 'marketIndex' in item;
};
